module.exports = __webpack_public_path__ + "assets/img/3.2d5cf911.jpg";